module.exports = __webpack_public_path__ + "img/motor_no72.eede2832.jpg";